import { render, staticRenderFns } from "./YelpReviewContent.vue?vue&type=template&id=38921b5c"
import script from "./YelpReviewContent.vue?vue&type=script&lang=js"
export * from "./YelpReviewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports